import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedalStarAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M14 6A6 6 0 1 1 2 6a6 6 0 0 1 12 0m-2-.5-1.59-.265A2 2 0 0 1 8.764 3.59L8.5 2h-1l-.265 1.59A2 2 0 0 1 5.59 5.236L4 5.5v1l1.59.265A2 2 0 0 1 7.236 8.41L7.5 10h1l.265-1.59a2 2 0 0 1 1.644-1.645L12 6.5z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M8 14c1.892 0 3.63-.657 5-1.755V16h-2zm0 0-3 2H3v-3.755A7.97 7.97 0 0 0 8 14"
	})]
});
export default SvgMedalStarAlt;
